module.exports = __webpack_public_path__ + "static/Enchante (6)-933e16df5311bea7914817b66a4ad2b7.jpeg";